import { api } from "@/lib/apiClient";
import type { Booking, Guest } from "@/types/camping";

export function shouldConfirmPlaceBanBeforeInquiry(
  booking: Booking,
  intent: "confirm" | "reject",
): boolean {
  return intent === "confirm" && Boolean(booking.place_ban_flagged);
}

export function collectPlaceBanGuestIds(
  booking: Booking,
  guest?: Guest | null,
): string[] {
  const ids = new Set<string>();
  if (booking.place_ban_matched_guest_id) {
    ids.add(booking.place_ban_matched_guest_id);
  }
  if (guest?.is_place_banned) {
    ids.add(guest.id);
  }
  return [...ids];
}

export async function liftPlaceBanForGuests(guestIds: string[]): Promise<void> {
  const unique = [...new Set(guestIds.filter(Boolean))];
  if (unique.length === 0) return;
  await Promise.all(
    unique.map((guestId) =>
      api.patch(`/api/v1/guests/${guestId}`, { is_place_banned: false }),
    ),
  );
}
